module.exports = __webpack_public_path__ + "static/man-thinking.1a207882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/man-thinking.svg
// module id = 463
// module chunks = 35783957827783